package twist.mena.sports.admin.state

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.window

/** The revamp (catalog) screens stay in the code but are hidden from the dashboard while this is false. */
const val SHOW_REVAMP = false

enum class Screen {
    LOGIN, VERIFY, OVERVIEW, TEAMS, LEAGUES, FIXTURES, PLAYERS, SYNC_RUNS, NOTIFICATIONS, ANALYTICS, AUTOMATION_TESTS, API_DOCS, LEGACY_API_DOCS,
    ADS, LEGACY_TEAMS, LEGACY_LEAGUES, LEGACY_PLAYERS, ENTITY_MAPPINGS
}

object NavState {
    var currentScreen by mutableStateOf(resolveInitialScreen())
        private set

    fun navigate(screen: Screen) {
        currentScreen = screen
    }

    private fun resolveInitialScreen(): Screen {
        val params = window.location.search
        if (params.contains("magic_token=")) {
            return Screen.VERIFY
        }
        return if (AuthState.isAuthenticated) Screen.OVERVIEW else Screen.LOGIN
    }

    fun getMagicToken(): String? {
        val params = window.location.search
        val prefix = "magic_token="
        val start = params.indexOf(prefix)
        if (start == -1) return null
        val valueStart = start + prefix.length
        val end = params.indexOf('&', valueStart).let { if (it == -1) params.length else it }
        return params.substring(valueStart, end)
    }
}
